<script>
    export let name;
    export let width = "";
    export let height = "";
</script>

<div style="height:{height}px">
    <a class="twitter-timeline" data-width={width} data-height={height} href="https://twitter.com/{name}">Tweets by TwitterDev</a>
    <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
</div>
